export const AlertTypeEnum = {
  minimalBalance: 'minimalBalance',
  declinedAuth: 'declinedAuth',
} as const;
export type AlertTypeEnum = (typeof AlertTypeEnum)[keyof typeof AlertTypeEnum];
